import { FunctionComponent } from 'react';
import { ButtonContainer } from './styles';
import { MarkReviewedButton } from '../Buttons/MarkReviewedButton';
import { ProductAccessStatus } from 'domain/product/enums';
import { ProductAccessButton } from '../Buttons/ProductAccessButton';
import { ProductRegistration } from 'domain/product/interfaces';
import { MontelAccount } from 'domain/account/interfaces';

interface PendingReviewCellProps {
	productRegistration: ProductRegistration | undefined;
	account: MontelAccount;
	onSuccessfulStatusUpdate: (
		productId: string,
		newStatus: ProductAccessStatus,
	) => void;
	onClickReview: (account: MontelAccount) => void;
}

export const PendingReviewCell: FunctionComponent<PendingReviewCellProps> = ({
	productRegistration,
	account,
	onSuccessfulStatusUpdate,
	onClickReview,
}) => (
	<ButtonContainer $minWidth="160px">
		<MarkReviewedButton
			productRegistration={productRegistration}
			account={account}
			onClickReview={onClickReview}
		/>
		<ProductAccessButton
			productRegistration={productRegistration}
			onSuccess={onSuccessfulStatusUpdate}
			userId={account.id}
		/>
	</ButtonContainer>
);
